import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rotate } from 'modules/common/utils/animations';
import { colors } from '../styles';

const size = 26;

const Spin = styled.div`
  height: ${props => props.objective && '100px'};
  position: ${props => props.objective && 'relative'};
`;

const MainLoader = styled.div`
  width: ${size}px;
  height: ${size}px;
  animation: ${rotate} 0.75s linear infinite;
  border: 2px solid ${colors.borderDarker};
  border-top-color: ${colors.colorPrimary};
  border-right-color: ${colors.colorPrimary};
  border-radius: 100%;
  margin: auto;
`;

function SpinnerIcon({ objective, style, iconStyle }) {
  style = style || {};
  iconStyle = iconStyle || {};
  return (
    <Spin objective={objective} style={style}>
      <MainLoader style={iconStyle}/>
    </Spin>
  );
}

SpinnerIcon.propTypes = {
  objective: PropTypes.bool,
  style: PropTypes.object
};

SpinnerIcon.defaultProps = {
  objective: false
};

export default SpinnerIcon;



// WEBPACK FOOTER //
// src/modules/common/components/SpinnerIcon.js